"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Formats as phone number
 * @param {String} value Preformatted value
 */

var phoneMatchPattern = /^(1)?(\d{0,3})?(\d{0,3})?(\d{0,4})?(\d*)?$/;
var phoneExtensionRE = /\s*[A-Za-z]+\s*/;
var toPhone = function toPhone(value) {
  if (!value) {
    return '';
  }
  var zeroth = value.charAt(0);
  if (zeroth === '+' || zeroth === '0') {
    return value; // don't try to format non-US numbers, beginning with + or 0
  }

  // if an extension is added, split it off
  var formattedSplit = value.split(phoneExtensionRE);

  // format number part
  var num = +formattedSplit[0];
  var reRes = phoneMatchPattern.exec(num);
  var formatted;
  if (reRes) {
    // we have something to format
    formatted = '';
    if (reRes[1]) {
      // '1', if it exists
      formatted += reRes[1];
    }
    if (reRes[2]) {
      // area code
      formatted += reRes[1] ? ' (' + reRes[2] : '(' + reRes[2];
    }
    if (reRes[3]) {
      formatted += ') ' + reRes[3];
    }
    if (reRes[4]) {
      formatted += '-' + reRes[4];
    }
  } else {
    formatted = formattedSplit[0];
  }
  if (formattedSplit.length > 1) {
    // add back 'extension... anything after letters in the original
    formatted += ' x' + formattedSplit[1];
  }
  return formatted;
};
var _default = toPhone;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-payment-calculator-v2/dist/client/components/scss/index.scss');